/* ============================================================
   KAFIE 1901 — v8 Journey clips

   There is no scroll choreography on this page any more. The sticky
   cross-fading stage was removed because it made the page feel
   "crammed and claustrophobic" and swapped clips before you could
   watch them. Every chapter now owns its media and the page scrolls
   normally, so this file does exactly one job: keep the clips
   playing.

   THE POLICY

   1. EVERYTHING NEAR THE SCREEN PLAYS AT ONCE. rootMargin is 150%
      of the viewport in both directions, so on a desktop that is
      roughly four bands live simultaneously — the one you are
      reading plus the ones above and below it. Nothing waits its
      turn and nothing cuts away.

   2. WHAT IS FAR OFF SCREEN IS PAUSED, and is not even fetched
      until it comes within that margin. Seven simultaneously
      decoding 1080p clips is what makes a page like this crawl on a
      phone; four is fine, seven is not. This is the ONLY reason the
      observer exists. If you widen the margin further, test on a
      phone before shipping it.

   3. A FAILED CLIP SHOWS ITS POSTER, NEVER BLACK. Every video
      element carries a poster and this file never hides one. Two
      chapters of the pre-v8 page rendered as flat black rectangles
      because their clips never loaded; that is not coming back.

   NOTE ON SOURCES: the mp4-only <source> list comes from
   snippets/v8-jx-sources.liquid. Shopify returns its HLS playlist
   FIRST in video.sources and desktop Chrome cannot play it. That
   snippet is why these clips play at all — read its comment before
   touching anything to do with sources.
   ============================================================ */
(function () {
  'use strict';

  var clips = [].slice.call(document.querySelectorAll('[data-jb-clip]'));
  if (!clips.length) return;

  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function play(v) {
    if (reduce) return;
    var p = v.play();
    /* Autoplay refusal is normal and survivable — the poster is
       already painted underneath, so swallow it silently. */
    if (p && p.catch) p.catch(function () {});
  }

  function wake(v) {
    if (!v.getAttribute('data-warm')) {
      v.setAttribute('data-warm', '1');
      v.preload = 'auto';
      v.load();
    }
    play(v);
  }

  clips.forEach(function (v) {
    v.muted = true;                 /* iOS ignores the attribute in places */
    v.setAttribute('muted', '');
    /* rule 3: on error keep the poster. A <video> keeps painting its
       poster after a source failure, so hiding it would be worse. */
    v.addEventListener('error', function () {
      v.setAttribute('data-failed', '1');
    }, true);
  });

  /* No IntersectionObserver (old Safari): just play everything. A
     slightly hot page beats a page of frozen posters. */
  if (!('IntersectionObserver' in window)) {
    clips.forEach(wake);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) wake(v);
      else if (!v.paused) v.pause();
    });
  }, { rootMargin: '150% 0px 150% 0px', threshold: 0 });

  clips.forEach(function (v) { io.observe(v); });
})();
